import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 用户管理一级
const userRouter: RouteConfig = {
  path: '/user',
  component: Layout,
  redirect: '/user/user-manage/user-info',
  meta: {
    title: '用户管理',
    icon: 'menu-user'
  },
  children: [
    {
      name: 'UserManage',
      path: 'user-manage',
      component: () => import('@/views/user/user-manage/index.vue'),
      redirect: '/user/user-manage/user-info',
      meta: {
        title: '用户管理'
      },
      children: [
        {
          name: 'UserInfo',
          path: 'user-info',
          component: () => import('@/views/user/user-manage/user-info.vue'),
          meta: {
            title: '用户信息'
          }
        },
        {
          name: 'UserDetail',
          path: 'user-detail',
          component: () => import('@/views/user/user-manage/user-detail.vue'),
          meta: {
            title: '用户详情页',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'UserCoin',
      path: 'user-coin',
      component: () => import('@/views/user/user-coin/index.vue'),
      redirect: '/user/user-coin/coin-manage',
      meta: {
        title: '兔币管理'
      },
      children: [
        {
          name: 'CoinManage',
          path: 'coin-manage',
          component: () => import('@/views/user/user-coin/coin-manage.vue'),
          meta: {
            title: '兔币管理'
          }
        }
      ]
    }
  ]
}

export default userRouter
